export default __webpack_public_path__ + "static/media/dental-assisting-3392127_1920.6ac67895.jpg";